module.exports = __webpack_public_path__ + "2b4aa081ca4397d893c0c5ad13a56b5c.svg";